module.exports = __webpack_public_path__ + "img/2025-0515-01-02.07283541.png";